const KeenSlider = window.KeenSlider

const { setInitialised, addWheelControls } = window.BAO.Carousel.plugins

class CompleteStyle extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (!this.els.slides?.exists || !this.els.slide?.exists) {
      return
    }

    this.handleMouseEnter = this.handleMouseEnter.bind(this)
    this.handleMouseLeave = this.handleMouseLeave.bind(this)

    this.setupHover()

    if (this.els.slide.elements.length <= 3) return

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        loop: false,
        rubberband: false,
        mode: 'snap',
        slides: {
          perView: 3,
          spacing: 2,
        },
      },
      [setInitialised(), addWheelControls('horizontal')],
    )
  }

  setupHover () {
    this.header = this.els.header.element
    this.productData = this.els['product-data'].element
    this.productTitle = this.els['product-title'].element
    this.productPrice = this.els['product-price'].element

    if (
      !this.header ||
      !this.productData ||
      !this.productTitle ||
      !this.productPrice
    ) {
      return
    }

    this.els?.slide?.elements.forEach(el => {
      this.listeners.add(el, 'mouseenter', this.handleMouseEnter)
    })

    this.listeners.add(
      this.els.slides.element,
      'mouseleave',
      this.handleMouseLeave,
    )
  }

  handleMouseEnter (e) {
    if (!window.BAO.MediaBreakpoints.isMd) return

    const slideEl = e.target.closest(this.els.slide.selector)
    if (!slideEl) return

    // Update title
    this.productTitle.innerText = slideEl.dataset.title

    // Update price
    const encodedPrice = slideEl.dataset.price
    const textareaEl = document.createElement('textarea')
    textareaEl.innerHTML = encodedPrice
    const priceEl = textareaEl.value
    this.productPrice.innerHTML = priceEl

    this.header.setAttribute('aria-hidden', 'true')
    this.productData.setAttribute('aria-hidden', 'false')
  }

  handleMouseLeave () {
    this.header.setAttribute('aria-hidden', 'false')
    this.productData.setAttribute('aria-hidden', 'true')
  }
}

if (!customElements.get('complete-style')) {
  customElements.define('complete-style', CompleteStyle)
}
